var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UploadLi',_vm._b({attrs:{"icon":_vm.phoneImg,"nameText":"","nameTip":""},on:{"upload":_vm.upload}},'UploadLi',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }